window.getStepTemplate = (stepType, stepInputLabel, stepInputCoordinates) => {
    let stepIcon = '';
    let secondIcon = '';
    let inputPlaceholder = '';
    let deleteIcon = '';
    let stepId = ''

    const startStepIcon = `
           <svg class="icon-start" xmlns="http://www.w3.org/2000/svg" width="8.692" height="12" viewBox="0 0 8.692 12">
               <g>
                   <path d="M4.346,0A4.351,4.351,0,0,0,0,4.346c0,2.974,3.889,7.34,4.055,7.524a.391.391,0,0,0,.582,0c.166-.184,4.055-4.55,4.055-7.524A4.351,4.351,0,0,0,4.346,0m0,6.532A2.187,2.187,0,1,1,6.532,4.346,2.189,2.189,0,0,1,4.346,6.532" fill="#c84c47"></path>
               </g>
           </svg>
       `;

    const intermediaryStepIcon = `
            <svg class="icon-between" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                <g transform="translate(-50.289 -185.5)">
                    <path d="M5.5,0A5.5,5.5,0,1,0,11,5.5,5.511,5.511,0,0,0,5.5,0" transform="translate(50.789 186)" fill="none" stroke="#707070" stroke-width="1"></path>
                    <g transform="translate(50.789 186)">
                        <path d="M7.615,6.346H6.346V7.514a.846.846,0,0,1-1.692,0V6.346H3.385a.846.846,0,0,1,0-1.692H4.654V3.385a.846.846,0,0,1,1.692,0V4.654H7.615a.846.846,0,0,1,0,1.692" fill="#646461"></path>
                    </g>
                </g>
            </svg>
        `;

    const endStepIcon = `
            <svg class="icon-end" xmlns="http://www.w3.org/2000/svg" width="9.965" height="12" viewBox="0 0 9.965 12">
                <g>
                    <path d="M.528,0h0a.528.528,0,0,1,.528.528V11.472a.528.528,0,1,1-1.056,0V.528A.528.528,0,0,1,.528,0" fill="#c84c47"></path>
                    <path d="M51.606,40.672,43.12,37.33v7.927l8.486-3.342A.668.668,0,0,0,51.606,40.672Z" transform="translate(-42.064 -36.416)" fill="#c84c47"></path>
                </g>
            </svg>
        `;

    const betweenStepIcon = `
            <div class="between-step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="2" height="21" viewBox="0 0 2 21">
                    <line y2="19" transform="translate(1 1)" fill="none" stroke="#707070" stroke-linecap="round" stroke-width="2" stroke-dasharray="0 9"></line>
                </svg>
            </div>
        `;

    const deleteStepIcon = `
            <div class="intermediate-delete-icon"></div>
        `;

    if (stepType === 1) {
        stepIcon = startStepIcon;
        secondIcon = betweenStepIcon;
        inputPlaceholder = 'D\'où voulez-vous partir ?';
        stepId = `id='start-step'`

    } else if (stepType === 2) {
        stepIcon = intermediaryStepIcon;
        secondIcon = betweenStepIcon;
        inputPlaceholder = 'Où souhaitez-vous aller ?';
        deleteIcon = deleteStepIcon;
    } else {
        stepIcon = endStepIcon;
        secondIcon = ``;
        inputPlaceholder = 'Où voulez-vous arriver ?';
        stepId = `id='end-step'`
    }

    const doc = new DOMParser().parseFromString(`
           <div ${stepId} class='roadtrip-step draggable'>
                <div class="step-icon">
                    ${stepIcon}
                    ${secondIcon}
                </div>
                <div class="mapbox-autocomplete-field">
                    <input class="step-input" type="text" placeholder="${inputPlaceholder}" value="${stepInputLabel}" coordinates="${stepInputCoordinates}"/>
                    <div class="mapbox-autocomplete-result hidden"></div>
                </div>
                ${deleteIcon}
            </div>
       `, 'text/html');

    return doc.querySelector('.roadtrip-step');
}